import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const GetAllPrivacyAgreement = createAsyncThunk(
  "masters/state/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.PrivacyAgreement}?name=${filter?.name || ""}&per_page=${
          filter?.per_page || IDS.PERPAGE
        }`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Get a specific state
export const GetPrivacyAgreement = createAsyncThunk(
  "masters/state/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.PrivacyAgreement}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create a new state
export const AddPrivacyAgreement = createAsyncThunk(
  "masters/state/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.PrivacyAgreement, data);
      return res; // The new state object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Update a state
export const UpdatePrivacyAgreement = createAsyncThunk(
  "masters/state/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.PrivacyAgreement}/${id}`, {
        name: data.name,
        country_id: data.country_id,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Delete a state
export const DeletePrivacyAgreement = createAsyncThunk(
  "masters/state/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.PrivacyAgreement}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Change the status of a state
export const StatusPrivacyAgreement = createAsyncThunk(
  "masters/state/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.PrivacyAgreement}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "privacy-agreement",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPrivacyAgreement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllPrivacyAgreement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllPrivacyAgreement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetPrivacyAgreement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetPrivacyAgreement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetPrivacyAgreement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AddPrivacyAgreement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddPrivacyAgreement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddPrivacyAgreement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(UpdatePrivacyAgreement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdatePrivacyAgreement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (stateItem) => stateItem.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdatePrivacyAgreement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(DeletePrivacyAgreement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeletePrivacyAgreement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = state.data.filter(
        //   (stateItem) => stateItem.id !== action.payload
        // );
        state.data = state.data.filter(
          (stateItem) => stateItem.id !== action.payload
        );
      })
      .addCase(DeletePrivacyAgreement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(StatusPrivacyAgreement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusPrivacyAgreement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (stateItem) => stateItem.id === action.payload?.id
        );
        if (index !== -1) {
          state.data[index].status = !state.data[index].status;
        }
      })
      .addCase(StatusPrivacyAgreement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
